import React from 'react'
import PropTypes from 'prop-types'
import './NavigationComponent.css'
import NavLink from './NavLink'

import UserLoginControl from '../UserLoginControl'
import SignUpControl from '../SignUpControl'
import UserLogoutControl from '../UserLogoutControl'
import AddDomainControl from '../AddDomainControl'
import AddDomainResourceControl from '../AddDomainResourceControl'
import AccountManagementControl from '../AccountManagementControl';

const NavigationComponent = (props) => {
	return (
		<div className="NavigationComponent">
			<UserLoginControl>
				<NavLink text={props.loginText}/>
			</UserLoginControl>
			<SignUpControl>
				<NavLink text={props.signUpText}/>
			</SignUpControl>
			<UserLogoutControl>
				<NavLink text={props.logoutText}/>
			</UserLogoutControl>
			<AddDomainControl>
				<NavLink text={props.addDomainText}/>
			</AddDomainControl>
			<AddDomainResourceControl>
				<NavLink text={props.addResourceText}/>
			</AddDomainResourceControl>
			<AccountManagementControl>
				<NavLink text={props.accountManagementText}/>
			</AccountManagementControl>
		</div>
	)
}

NavigationComponent.propTypes = {
	loginText: PropTypes.string.isRequired,
	signUpText: PropTypes.string.isRequired,
	logoutText: PropTypes.string.isRequired,
	addDomainText: PropTypes.string.isRequired,
	addResourceText: PropTypes.string.isRequired,
    accountManagementText: PropTypes.string.isRequired,
}

NavigationComponent.defaultProps = {
	loginText: "Log In",
	signUpText: "Sign Up",
	logoutText: "Log Out",
	addDomainText: "Add Domain",
	addResourceText: "Add Resource",
    accountManagementText: "Account",
}

export default NavigationComponent


// WEBPACK FOOTER //
// ./src/components/NavigationComponent/NavigationComponent.js